module.exports = __webpack_public_path__ + "img/ar_m_2.51b6e637.jpg";